module.exports = __webpack_public_path__ + "img/img44.a199d36f.svg";